/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Jointeamdescription2Inputs */

const zh_learn_jointeamdescription2 = /** @type {(inputs: Learn_Jointeamdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该分享内容仅对团队成员开放。加入后即可开始学习。`)
};

const en_learn_jointeamdescription2 = /** @type {(inputs: Learn_Jointeamdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This shared session is limited to team members. Join first, then start learning.`)
};

const es_learn_jointeamdescription2 = /** @type {(inputs: Learn_Jointeamdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta sesión compartida está limitada a miembros del equipo. Únete primero y luego empieza a estudiar.`)
};

/**
* | output |
* | --- |
* | "This shared session is limited to team members. Join first, then start learning." |
*
* @param {Learn_Jointeamdescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_jointeamdescription2 = /** @type {((inputs?: Learn_Jointeamdescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Jointeamdescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_jointeamdescription2(inputs)
	if (locale === "en") return en_learn_jointeamdescription2(inputs)
	return es_learn_jointeamdescription2(inputs)
});
export { learn_jointeamdescription2 as "learn_joinTeamDescription" }